import { render, staticRenderFns } from "./PolicySuccessPage.vue?vue&type=template&id=f1810592&scoped=true"
import script from "./PolicySuccessPage.vue?vue&type=script&lang=js"
export * from "./PolicySuccessPage.vue?vue&type=script&lang=js"
import style0 from "./PolicySuccessPage.vue?vue&type=style&index=0&id=f1810592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1810592",
  null
  
)

export default component.exports